import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { http } from '../config';
import {
  IAddCardPostRequestPayload,
  IAddCardPostResponse,
  IDeleteCardRequestPayload,
  IDeleteCardResponse,
  IPaymentMethodsGetResponse,
  ISetDefaultCardPostRequestPayload,
  ISetDefaultCardPostResponse,
} from '../../types';
import { toast } from 'react-toastify';

interface IPayment {
  listPaymentMethods: () => Promise<IPaymentMethodsGetResponse>;
  addCard: (
    payload: IAddCardPostRequestPayload
  ) => Promise<IAddCardPostResponse>;
  setDefaultCard: (
    payload: ISetDefaultCardPostRequestPayload
  ) => Promise<ISetDefaultCardPostResponse>;
  deleteCard: (
    payload: IDeleteCardRequestPayload
  ) => Promise<IDeleteCardResponse>;
}
export const payment: IPayment = {
  listPaymentMethods: () => http.criticalGet(`/api/auth/customer_tokens/cards`),
  addCard: (payload) =>
    http.criticalPost(`/api/auth/customer_tokens/cards/add-card`, payload),
  setDefaultCard: (payload) =>
    http.criticalPatch(
      `api/auth/customer_tokens/cards/${payload.unique_id}/set-default`
    ),
  deleteCard: (payload) =>
    http.criticalDelete(`/api/auth/customer_tokens/cards/${payload.unique_id}`),
};
export const usePaymentMethods = (enabled:boolean = true) => {
  return useQuery({
    queryKey: ['list-payment-methods'],
    queryFn: () => payment.listPaymentMethods(),
    enabled
  });
};
export const useAddCard = () => {
  return useMutation({
    mutationKey: ['add-payment-method'],
    mutationFn: payment.addCard,
    onSuccess: (res) => {
      // toast.success('Payment added successfully');
      window.location.assign(res.redirection_url);
    },
    // onError: (response) => toast.error(response.message),
  });
};
export const useSetDefaultCard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['set-default-payment-method'],
    mutationFn: payment.setDefaultCard,
    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: ['list-payment-methods'],
      });
      toast.success(response.message);
    },
    onError: (response) => toast.error(response.message),
  });
};
export const useDeleteCard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['delete-payment-method'],
    mutationFn: payment.deleteCard,
    onSuccess: () => {
      // toast.success('Payment method deleted successfully');
      
      queryClient.invalidateQueries({
        queryKey: ['list-payment-methods'],
        refetchType: 'all',
      });
    },
    onError: (response) => toast.error(response.message),
  });
};
